function TopAd() {
  return (
    <div className='top-ad'>
      <p>Free delivery on orders over $30.</p>
    </div>
  );
}

export default TopAd;

